module.exports = __webpack_public_path__ + "img/VentureWallet_Mac_Demo_600px.b0164f6c.jpg";